import React, { memo, useMemo } from "react";
import { useIframe } from "../../hooks";

export const TabIframeOqt = memo((props) => {
  const { item, panel } = props;
  const { src, ...otherProps } = panel;
  const { resolveMatches } = useIframe();
  const newSrc = useMemo(() => resolveMatches(src, {form: item}), [src, item]); 
  return (
    <iframe width="100%" style={{border: "0px", height: "100%"}} {...otherProps} src={newSrc}></iframe>
  );
})